import React from 'react';
import cx from 'classnames';
import type { GroupConsumerProps } from 'rc-image/lib/PreviewGroup';
import InternalPreviewGroup from 'antd/lib/image/PreviewGroup';

import styles from './Image.Thumbnails.module.scss';

export interface IImageGroupProps extends GroupConsumerProps {
  enablePreview?: boolean;
  className?: string;
}

export type TImageGroup = typeof InternalPreviewGroup;

/**
 * Preview group component
 */
export const ImageGroup: TImageGroup = (props: IImageGroupProps) => {
  const { enablePreview, className } = props;
  if (enablePreview) {
    return (
      <div className={cx(styles.ImageGroupWithPreview, className)}>
        <InternalPreviewGroup {...props} />
      </div>
    );
  }

  return (
    <div className={cx(styles.ImageGroupNoPreview, className)}>
      <InternalPreviewGroup {...props} preview={{ visible: false }} />
    </div>
  );
};
